(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(34045);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MainLayout.tsx
var MainLayout = __webpack_require__(63286);
// EXTERNAL MODULE: ./src/component/home/renewal/main/mobile/MainContentsMobile.tsx
var MainContentsMobile = __webpack_require__(70436);
// EXTERNAL MODULE: ./src/component/home/renewal/main/mobile/MainFooterMobile.tsx
var MainFooterMobile = __webpack_require__(40191);
// EXTERNAL MODULE: ./src/component/home/renewal/main/mobile/MainGnbMobile.tsx + 1 modules
var MainGnbMobile = __webpack_require__(43775);
;// CONCATENATED MODULE: ./src/component/home/renewal/main/mobile/MainPageMobile.tsx





var MainPageMobile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* MainLayout */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainGnbMobile/* MainGnbMobile */.j, {
                type: "client"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContentsMobile/* MainContentsMobile */.W, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainFooterMobile/* MainFooterMobile */.w, {})
        ]
    });
};
/* harmony default export */ var mobile_MainPageMobile = (MainPageMobile);

// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MainContents.tsx
var MainContents = __webpack_require__(33827);
// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MainFooter.tsx
var MainFooter = __webpack_require__(62579);
// EXTERNAL MODULE: ./src/component/home/renewal/main/pc/MainGnb.tsx
var MainGnb = __webpack_require__(9561);
;// CONCATENATED MODULE: ./src/component/home/renewal/main/pc/MainPage.tsx





var MainPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* MainLayout */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainGnb/* MainGnb */.F, {
                type: "client"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContents/* MainContents */.m, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainFooter/* MainFooter */.j, {})
        ]
    });
};
/* harmony default export */ var pc_MainPage = (MainPage);

// EXTERNAL MODULE: ./src/component/v2/ChatInterface.tsx + 2 modules
var ChatInterface = __webpack_require__(88094);
// EXTERNAL MODULE: ./src/component/v2/LeadCaptureModal.tsx + 4 modules
var LeadCaptureModal = __webpack_require__(90244);
// EXTERNAL MODULE: ./src/hook/usePageScrollHook.ts
var usePageScrollHook = __webpack_require__(96154);
// EXTERNAL MODULE: ./src/state/index.ts
var state = __webpack_require__(51413);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(4480);
;// CONCATENATED MODULE: ./pages/index.tsx












var faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
        {
            "@type": "Question",
            name: "전문가 매칭에는 기간이 얼마나 소요되나요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "사안에 따라 다르지만 평균적으로 영업일 기준 3일 내에 최적 전문가를 추천해드리며, 7일 내에 원하는 전문가와 협업을 시작할 수 있습니다."
            }
        },
        {
            "@type": "Question",
            name: "원포인트에서 어떤 전문가와 함께 일할 수 있나요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "마케팅과 관련된 모든 전문가를 보유하고 있습니다. 세부적으로는 퍼포먼스 마케터 / 콘텐츠 마케터 / 브랜드 마케터 / CRM 마케터 / 디자이너 / 카피라이터가 있습니다."
            }
        },
        {
            "@type": "Question",
            name: "전문가에게 어떤 업무를 요청할 수 있을까요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "전문가와 사전에 협의된 예상 시간/업무 범위 내에서라면 어떤 업무든 요청 가능합니다. 원포인트는 전문가 '고용' 서비스 입니다. 풀타임 정규직 팀원에게 요청 주시는 것과 동일한 방식으로 협업하시면 됩니다."
            }
        },
        {
            "@type": "Question",
            name: "서비스 비용은 어떻게 책정되나요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "전문가가 직접 4주 기준 인건비를 제안하며, 이력 및 역량 수준과 업무 난이도를 고려하여 책정하게 됩니다. 정확한 비용은 전문가 제안 시 알 수 있지만, 평균 단가는 상담 시 안내해드립니다. 전문가가 제시한 인건비 외에 추가 비용은 없습니다."
            }
        },
        {
            "@type": "Question",
            name: "필요에 따라 주 활용 시간을 변경할 수 있나요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "네, 주 활용 시간은 5시간부터 40시간까지 자유롭게 변경 가능합니다. 단, 계약 단위에 맞춰 4주 단위로 가능하며, 실제 업무 수행 시간이 계약 시간보다 자주 초과하는 경우에 한해서 4주 내에 상향 조정이 가능합니다. 모든 의사 결정은 고객사 - 전문가 합의 하에 진행됩니다."
            }
        },
        {
            "@type": "Question",
            name: "전문가와 업무는 어떻게 하나요?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "대부분의 경우 비대면 형태로 업무하지만, 전문가와의 협의 하에 대면, 비대면, 혼합 (대면+비대면) 등 다양한 형태로 진행 가능합니다."
            }
        }, 
    ]
};
var Home = function(props) {
    var ref = (0,react.useState)(props.isPc), isPc = ref[0], setIsPc = ref[1];
    var setIsApplyOpen = (0,es/* useSetRecoilState */.Zl)(state/* isApplyOpenAtom */.Vu);
    var setIsChatOpen = (0,es/* useSetRecoilState */.Zl)(state/* isChatOpenAtom */.P2);
    var setUserInfo = (0,es/* useSetRecoilState */.Zl)(state/* userInfoAtom */.wl);
    var userInfo = (0,es/* useRecoilValue */.sJ)(state/* userInfoAtom */.wl);
    var isApplyOpen = (0,es/* useRecoilValue */.sJ)(state/* isApplyOpenAtom */.Vu);
    var isChatOpen = (0,es/* useRecoilValue */.sJ)(state/* isChatOpenAtom */.P2);
    var defaultMessage = (0,es/* useRecoilValue */.sJ)(state/* defaultMessageAtom */.Em);
    var setSnackbareState = (0,es/* useSetRecoilState */.Zl)(state/* globalSnackbarState */.j8);
    var aiMatchUuid = (0,es/* useRecoilValue */.sJ)(state/* aiMatchUuidAtom */.MC);
    (0,react.useEffect)(function() {
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("chat") === "true") {
            if (userInfo.name) {
                setIsChatOpen(true);
            } else {
                setIsApplyOpen(true);
            }
        }
        if (urlParams.get("apply") === "true") {
            setIsApplyOpen(true);
        }
    }, []);
    (0,react.useEffect)(function() {
        var handleResize = function() {
            if (window.innerWidth >= 1176) {
                setIsPc(true);
            } else {
                setIsPc(false);
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    var breadcrumbListStructuredData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://1point.kr"
            }, 
        ]
    };
    var organizationStructuredData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "원포인트",
        url: "https://1point.kr",
        logo: "https://1point.kr/static/logo_white.png",
        sameAs: [
            "https://www.linkedin.com/showcase/one-point-kr/posts/?feedView=all",
            "https://www.instagram.com/onepoint.official/",
            "https://www.facebook.com/1point.official/",
            "https://www.youtube.com/@1point.official", 
        ]
    };
    var addressStructuredData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "롸잇",
        address: {
            "@type": "PostalAddress",
            postalCode: "06236",
            addressRegion: "서울",
            addressLocality: "서울 강남구",
            streetAddress: "26길 14 위워크빌딩 10층 10-102호"
        }
    };
    (0,usePageScrollHook/* usePageScrollHook */.y)("client");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://1point.kr"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(breadcrumbListStructuredData)
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(organizationStructuredData)
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(addressStructuredData)
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(faqStructuredData)
                        }
                    })
                ]
            }),
            isPc ? /*#__PURE__*/ (0,jsx_runtime.jsx)(pc_MainPage, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_MainPageMobile, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadCaptureModal/* LeadCaptureModal */.Z, {
                isOpen: isApplyOpen,
                onClose: function() {
                    return setIsApplyOpen(false);
                },
                onSubmit: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            setUserInfo(data);
                            setIsApplyOpen(false);
                            setIsChatOpen(true);
                            return [
                                2
                            ];
                        });
                    });
                    return function(data) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatInterface/* ChatInterface */.f, {
                isOpen: isChatOpen,
                onClose: function() {
                    return setIsChatOpen(false);
                },
                userInfo: userInfo,
                defaultMessage: defaultMessage
            })
        ]
    });
};
Home.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var req, isPc, userAgent, userAgent1, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            req = param.req;
            isPc = false;
            if (req) {
                userAgent = req.headers["user-agent"];
                isPc = /Windows|Macintosh|Linux/i.test(userAgent);
            } else {
                userAgent1 = navigator.userAgent;
                isPc = /Windows|Macintosh|Linux/i.test(userAgent1);
            }
            _tmp = {};
            return [
                2,
                (_tmp.isPc = isPc, _tmp)
            ];
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 96154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ usePageScrollHook; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1785);
/* harmony import */ var react_gtm_module__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_gtm_module__WEBPACK_IMPORTED_MODULE_1__);


var scrollDepthsList = {
    expert: [
        "",
        "WHITC3YK",
        "TJVD56IW",
        "JKZGJLVC",
        "FO9VNNMT"
    ],
    client: [
        "",
        "25%",
        "50%",
        "75%",
        "90%"
    ]
};
var scrollDepths = [
    0,
    25,
    50,
    75,
    90
];
var usePageScrollHook = function(eventType) {
    var scrollTriggered = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    var handleScroll = function() {
        var scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
        var scrollPosition = window.scrollY;
        var currentScrollPercent = scrollPosition / scrollHeight * 100;
        scrollDepths.forEach(function(depth, index) {
            var ref;
            var eventId = scrollDepthsList[eventType][index];
            if (currentScrollPercent >= depth && !(scrollTriggered === null || scrollTriggered === void 0 ? void 0 : (ref = scrollTriggered.current) === null || ref === void 0 ? void 0 : ref[depth]) && eventId) {
                scrollTriggered.current[depth] = true;
                var tagManagerArgs = {
                    dataLayer: {
                        event: "client-scroll",
                        depth: eventId
                    }
                };
                react_gtm_module__WEBPACK_IMPORTED_MODULE_1___default().dataLayer(tagManagerArgs);
            }
        });
    };
    //
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var eventId = scrollDepthsList[eventType][0];
        if (eventId) {
            scrollTriggered.current[0] = true;
            var tagManagerArgs = {
                dataLayer: {
                    event: "client-scroll",
                    depth: eventId
                }
            };
            react_gtm_module__WEBPACK_IMPORTED_MODULE_1___default().dataLayer(tagManagerArgs);
        }
    }, [
        eventType
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,3978,9522,4170,8068,2256,2133,1088,6371,3827,1272,5637,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);